import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { mergeClassNames } from '../../../../utils';
const MapLegendItem = ({ title, isDivider, children, }) => (_jsxs("div", { className: mergeClassNames({ 'border-b mb-2': isDivider }), children: [_jsx("p", { className: "font-sm capitalize text-gray-900", children: title }), _jsx("div", { className: "flex justify-start items-center py-3 flex-wrap gap-x-4 gap-y-1.5", children: children })] }));
MapLegendItem.defaultProps = {
    isDivider: false,
};
MapLegendItem.propTypes = {
    title: PropTypes.string,
    isDivider: PropTypes.bool,
    children: PropTypes.node,
};
export default MapLegendItem;
